import React from 'react'

interface FullPageCustomSectionProps {
  title: React.ReactNode
  description?: React.ReactNode
  image?: any
  isTitleCentered?: boolean
  isSingleCol?: boolean
  goToLink?: string | React.ReactNode
  children?: React.ReactNode
}

const FullPageCustomSection: React.FC<FullPageCustomSectionProps> = ({
  title,
  description,
  image,
  children,
  isTitleCentered,
  isSingleCol,
  goToLink
}) => {
  return (
    <div className="container mx-auto px-6 pt-16 relative h-full sm:pt-32 md:pt-0 lg:px-8">
      <div className="w-full flex flex-col h-full">
        <div className="row flex flex-wrap justify-center grow pt-16">
          <div className="texts mb-4 mt-8 flex flex-col pr-4 md:mt-0 md:justify-center xs:mb-0 xs:pr-4 sm:pr-0">
            <>{title}</>
            <div className="descriptionContainer pt-4 font-medium text-xs leading-relaxed xs:text-base md:pt-4 md:text-lg">
              {description}
            </div>
          </div>
        </div>
        <div className="servicesContainer flex flex-col px-4 mb-6 w-full lg:px-8">
          {children}
        </div>
      </div>
    </div>
  )
}

export default FullPageCustomSection
